import airnz from './airnz';
import alinta from './alinta';
import amplifon from './amplifon';
import auspost from './auspost';
import belong from './belong';
import bnz from './bnz';
import { Organisation } from './domain';
import hcf from './hcf';
import mycar from './mycar';
import ta from './ta';
import telstra from './telstra';
import telstraBusiness from './telstraBusiness';
import tge from './tge';
import tsa from './tsa';
import vga from './vga';

const exports: { [key: string]: Organisation } = {
  airnz,
  amplifon,
  auspost,
  belong,
  bnz,
  telstra,
  tge,
  tsa,
  hcf,
  alinta,
  vga,
  telstra_business: telstraBusiness,
  mycar,
  ta,
};

export default exports;
